webpackJsonp([213534597649335],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__(99);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fullscreen = function Fullscreen(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      firstItem = _ref.firstItem;
	
	  var containerClassName = (0, _classnames2.default)(firstItem ? _stylesModule2.default.first : _stylesModule2.default.fullscreen, className);
	
	  return _react2.default.createElement(
	    'div',
	    { className: containerClassName },
	    children
	  );
	};
	
	exports.default = Fullscreen;
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fullscreen":"src-components-fullscreen----styles-module---fullscreen---1zd9L","first":"src-components-fullscreen----styles-module---first---1NMJC src-components-fullscreen----styles-module---fullscreen---1zd9L"};

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(41);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _outboundLink = __webpack_require__(13);
	
	var _outboundLink2 = _interopRequireDefault(_outboundLink);
	
	var _fullscreen = __webpack_require__(77);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _meta = __webpack_require__(32);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _wrapper = __webpack_require__(9);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _stylesModule = __webpack_require__(329);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(_ref) {
	  var location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_meta2.default, { location: location }),
	    _react2.default.createElement(
	      _fullscreen2.default,
	      { className: _stylesModule2.default.intro, firstItem: true },
	      _react2.default.createElement(
	        _wrapper2.default,
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Hello. I\u2019m Shoaib Burq (aka: sabman)',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'I\u2019m a software & geomatics engineer',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Check out my ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _stylesModule2.default.link, to: '/work' },
	            'work'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'You can also checkout my ',
	          _react2.default.createElement(
	            _outboundLink2.default,
	            { className: _stylesModule2.default.link, to: 'https://medium.com/@sabman' },
	            'writings'
	          ),
	          ', ',
	          _react2.default.createElement(
	            _outboundLink2.default,
	            { className: _stylesModule2.default.link, to: 'https://github.com/sabman' },
	            'code'
	          ),
	          ', ',
	          _react2.default.createElement(
	            _outboundLink2.default,
	            { className: _stylesModule2.default.link, to: 'https://soundcloud.com/sabman' },
	            'music'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"intro":"src-pages----styles-module---intro---2Dr5P","link":"src-pages----styles-module---link---3nvcj"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-512c723b5389e8dbe42d.js